import { applyUtmData, createBookingDateTimeManager, createBookingDateTimeManagerCRM } from "./utils";
import GeneralBookingForm from "./_GeneralBookingForm";
import GeneralBookingFormCrm from "./_GeneralBookingFormCrm";
import HospitalBooking from "./HospitalBooking";
import PackageBooking from "./PackageBooking";
import QRLogin from "./_QRLogin";
import DanhyAppAd from "./_DanhyAppAd";

export default class BookingForm {
  constructor() {
    applyUtmData();

    if ($("#birthday-input").length) {
      $("#birthday-input").datetimepicker({
        format: "d/m/Y",
        timepicker: false,
        maxDate: new Date(),
        scrollInput: false,
      });
    }

    if ($("#package-birthday-input").length) {
      $("#package-birthday-input").datetimepicker({
        format: "d/m/Y",
        timepicker: false,
        maxDate: new Date(),
        scrollInput: false,
      });
    }

    if ($("#booking-datetime-input").length) {
      $("#booking-datetime-input")
        .prop("readonly", true)
        .attr("aria-readonly", "true")
        .datetimepicker({
          format: "d/m/Y",
          timepicker: false,
          minDate: new Date(),
          scrollInput: false,
        });
    }

    this.dateTimeManager = createBookingDateTimeManager();
    this.dateTimeManagerCRM = createBookingDateTimeManagerCRM();
    this.qrLogin = new QRLogin();
    if ($("#booking-danhy-app-ad").length && $(".booking-form-crm-danhy").length) {
      this.danhyAppAd = new DanhyAppAd();
    }

    const managers = {
      slot: this.dateTimeManager,
      crm: this.dateTimeManagerCRM,
    };

    // General booking form
    this.generalForm = new GeneralBookingForm({ managers });

    // CRM-integrated booking form
    this.integratedForm = new GeneralBookingFormCrm({
      managers,
      dateTimeManager: this.dateTimeManagerCRM,
    });

    this.hospitalForm = new HospitalBooking({ managers });

    this.packageForm = new PackageBooking({
      dateTimeManager: this.dateTimeManager,
    });

    this.bootDanhySession();

    // Prefetch SockJS while the user is still on the booking form.
    if ($(".booking-danhy-cta").length) {
      this.qrLogin.warmSocket();
    }
  }

  async bootDanhySession() {
    const leftoverOauth = this.qrLogin.consumeAbandonedKeycloakReturn();
    await this.qrLogin.restoreSessionIfNeeded();
    if (
      leftoverOauth &&
      $("#integrated-booking-form, #the-hospital-booking-form").first().attr("data-danhy-logged-in") !== "1"
    ) {
      this.qrLogin.startHoanMyLogin();
    }
  }
}
